<template>
  <v-card class="mx-auto" max-width="344" height="175" max-height="175">
    <v-card-text>
      <div>{{ card_title }}</div>
      <p class="text-h4 text--primary">
        {{ primary_text }}
      </p>
    </v-card-text>

  </v-card>
</template>
<script>
export default {
    name: "common-card",
    props:{
        primary_text: Number,
        card_title: String
    }
}
</script>